import { createElement } from 'react'
import { render, unmountComponentAtNode } from 'react-dom'
import { useTranslation } from 'react-i18next'
import { StyledActionSheet } from './styled'

interface SheetData {
  key?: string
  label: string
  url?: string
}

export const ActionSheetComp: React.FC<{
  data: SheetData[]
  showCancel: boolean
  onCancel: () => void
}> = ({ data, showCancel, onCancel }) => {
  const { t } = useTranslation()

  return (
    <StyledActionSheet>
      <div className="lon-action-sheet__content">
        <div className="lon-action-sheet__list">
          {data.map((item) => {
            if (item.url)
              return (
                <a href={item.url} key={item.key}>
                  <div className="lon-action-sheet__item" key={item.key}>
                    {item.label}
                  </div>
                </a>
              )
            return (
              <div className="lon-action-sheet__item" key={item.key}>
                {item.label}
              </div>
            )
          })}
        </div>
        {showCancel && (
          <div className="lon-action-sheet__cancel" onClick={onCancel}>
            {t('cancel')}
          </div>
        )}
      </div>
    </StyledActionSheet>
  )
}

class ActionSheet {
  container?: HTMLElement
  root: HTMLElement

  constructor(container?: HTMLElement) {
    this.container = container
  }

  show(sheetData = [], showCancel = true) {
    if (!this.container) {
      this.container = document.createElement('div')
      this.container.classList.add('lon-action-sheet__el')
      this.root = document.getElementById('__next')
      this.root.append(this.container)
    }

    const SheetEl = createElement(ActionSheetComp, {
      data: sheetData,
      showCancel,
      onCancel: this.destroy.bind(this),
    })

    render(SheetEl, this.container)
  }

  destroy() {
    if (this.root && this.container) {
      unmountComponentAtNode(this.container)
    }
  }
}

export const actionsheet = new ActionSheet()

export default ActionSheetComp
